/**
 * Configuration for a single insight card on the analytics dashboard.
 * The metric value is read from the latest analytics row (e.g. last period).
 */
export interface AnalyticsInsightCardConfig {
	/** Card title (e.g. "Open Findings"). */
	title: string;
	/** Card subtitle shown below the title (e.g. "Total Open Findings"). */
	subtitle: string;
	/** Key of the latest analytics row to display as the value. */
	metric: string;
	/** Optional additional CSS class names to apply to the value element (the element with insight-card__value-number).*/
	valueClassName?: string;
  /** Optional unit for the value (e.g. "days", "findings"). If set, the value will be displayed with the unit. */
  unit?: string;
}

/**
 * Insight cards configuration: array of up to 4 cards. Order determines display order.
 */
export type AnalyticsInsightCardsConfig = AnalyticsInsightCardConfig[];

export const DEFAULT_ANALYTICS_INSIGHT_CARDS_CONFIG: AnalyticsInsightCardsConfig = [
	{
		title: 'Open Findings',
		subtitle: 'Total Open Findings',
		metric: 'count',
	},
	{
		title: 'Findings Closed',
		subtitle: 'Total Findings Closed',
		metric: 'findingsClosed',
	},
	{
		title: 'Average Finding Age',
		subtitle: 'Average age of open Findings',
		metric: 'averageAge',
    unit: 'days',
	},
	{
		title: 'Average Finding Age',
		subtitle: 'Average age of closed Findings',
		metric: 'averageClosedAge',
    unit: 'days',
	},
];
